import { useOrby } from "../components/OrbyProvider/OrbyProvider.js";
import { orbyActions } from "@orb-labs/orby-viem-extension";
import { useCallback, useEffect, useState } from "react";
import { createClient, http } from "viem";
export const useVirtualNode = (address, platformId) => {
    const [isLoading, setIsLoading] = useState(false);
    const [virtualNode, setVirtualNode] = useState(undefined);
    const { getCachedVirtualNode, accountCluster, cacheVirtualNode, getBaseClient } = useOrby();
    const maybeCreateVirtualNode = useCallback(async () => {
        setIsLoading(true);
        try {
            if (!address || !platformId) {
                return;
            }
            const cachedNode = getCachedVirtualNode(address, platformId);
            if (cachedNode) {
                setVirtualNode(cachedNode);
                return cachedNode;
            }
            const baseClient = getBaseClient(platformId);
            if (!baseClient) {
                return undefined;
            }
            else if (!accountCluster?.accountClusterId) {
                return undefined;
            }
            const virtualNodeRpcUrl = await baseClient?.getVirtualNodeRpcUrl(accountCluster?.accountClusterId, platformId, address);
            const newVirtualNode = createClient({
                transport: http(virtualNodeRpcUrl),
                // @ts-ignore
            }).extend(orbyActions);
            setVirtualNode(newVirtualNode);
            cacheVirtualNode(address, platformId, newVirtualNode);
        }
        catch (error) {
            console.error("[useVirtualNode]", error);
        }
        finally {
            setIsLoading(false);
        }
    }, [accountCluster?.accountClusterId, address, cacheVirtualNode, getCachedVirtualNode, getBaseClient, platformId]);
    useEffect(() => {
        maybeCreateVirtualNode();
    }, [maybeCreateVirtualNode]);
    return { virtualNode, isLoading };
};
